<template>
  <div>
    <div class="chat-item chat-item--question">
      <writing-animation v-if="show.writing_1"></writing-animation>
      <transition name="fade">
        <div class="chat-item__inr" v-if="show.question">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              <span class="question__txt">承知しました！今はどちらにお住まいですか？</span>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div
      class="chat-item chat-item--anser chat-item--select"
      :class="displayUserIconClass($parent.formData.sex)"
      :data-name="displayIconName($parent.formData.name_sei)"
      v-if="show.answer_1"
    >
      <transition name="fade">
        <div class="chat-item__inr">
          <div class="select--col1">
            <select
              v-model="pref"
              title="pref"
              @change="changePrefAction"
              :class="{fontBlack: isPrefFontBlack}"
            >
              <option value="">都道府県</option>
              <option
                v-for="(option, key) in prefs"
                :key="key"
                :value="option.id"
              >{{ option.name }}</option>
            </select>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <button
          class="chat-item--anser__button"
          type="button"
          :disabled="isDisabled.pref"
          @click.once="clickFixPref"
          @click="changePrefData"
        >{{ btnContent.pref }}</button>
      </transition>
    </div>
    <transition name="fade">
      <div
        class="chat-item chat-item--anser"
        :class="displayUserIconClass($parent.formData.sex)"
        :data-name="displayIconName($parent.formData.name_sei)"
        v-if="show.fix_1"
      >
        <div class="chat-item__inr">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              {{ displayPrefName($parent.formData.pref) }}
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="chat-item chat-item--question" v-if="show.writing_2 || show.confirmMessage_1">
      <writing-animation v-if="show.writing_2"></writing-animation>
      <transition name="fade">
        <div class="chat-item__inr" v-if="show.confirmMessage_1">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              <template v-if="is004Path || is005Path">
                働きたい都道府県はどこですか？
              </template>
              <template v-else>
                <span class="txt-or">「{{ displayPrefName($parent.formData.pref) }}」</span>にお住まいなのですね。働きたい都道府県はどこですか？
              </template>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div
      class="chat-item chat-item--anser chat-item--select"
      :class="displayUserIconClass($parent.formData.sex)"
      :data-name="displayIconName($parent.formData.name_sei)"
      v-if="show.answer_2"
    >
      <transition name="fade">
        <div class="chat-item__inr">
          <div class="select--col1">
            <select
              v-model="workplace"
              title="workplace"
              @change="changeWorkplaceAction"
              :class="{fontBlack: isWorkplaceFontBlack}"
            >
              <option value="">希望勤務地</option>
              <option
                v-for="(option, key) in workplacePrefs"
                :key="key"
                :value="option.id"
              >{{ option.name }}</option>
            </select>
            <small>※複数ある場合は第一希望の勤務地を選んでください</small>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <button
          class="chat-item--anser__button"
          type="button"
          :disabled="isDisabled.workplace"
          @click.once="clickFixWorkplace"
          @click="changeWorkplaceData"
        >{{ btnContent.workplace }}</button>
      </transition>
    </div>
    <transition name="fade">
      <div
        class="chat-item chat-item--anser"
        :class="displayUserIconClass($parent.formData.sex)"
        :data-name="displayIconName($parent.formData.name_sei)"
        v-if="show.fix_2"
      >
        <div class="chat-item__inr">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              {{ displayPrefName($parent.formData.workplace) }}
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="chat-item chat-item--question" v-if="show.writing_3 || show.confirmMessage_2">
      <writing-animation v-if="show.writing_3"></writing-animation>
      <transition name="fade">
        <div class="chat-item__inr" v-if="show.confirmMessage_2">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              <span class="txt-or">「{{ displayPrefName($parent.formData.workplace) }}」</span>ですね！求人を調べておきます！
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import GenderMixin from '../../mixins/GenderMixin'
import prefsMixin from '../../mixins/PrefsMixin'
import functionsMixin from '../../mixins/functionsMixin'
import PathMixin from '../../mixins/PathMixin'
import WritingAnimation from '../animations/WritingAnimation'
export default {
  name: 'FormPrefAndWorkplace',
  mixins: [GenderMixin, prefsMixin, functionsMixin, PathMixin],
  components: {
    WritingAnimation
  },
  data: function () {
    return {
      show: {
        writing_1: true,
        question: false,
        answer_1: false,
        next_1: false,
        fix_1: false,
        writing_2: false,
        confirmMessage_1: false,
        answer_2: false,
        next_2: false,
        fix_2: false,
        writing_3: false,
        confirmMessage_2: false
      },
      isDisabled: {
        pref: true,
        workplace: true
      },
      isFix: {
        pref: false,
        workplace: false
      },
      btnContent: {
        pref: '次へ',
        workplace: '次へ'
      },
      pref: '',
      workplace: '',
      isPrefFontBlack: false,
      isWorkplaceFontBlack: false
    }
  },
  mounted: function () {
    if (this.is004Path || this.is005Path) {
      // LP004 or 005の場合は、お住まいの質問はスキップし、希望の就業場所から始める
      setTimeout(function () {
        this.show.writing_1 = false
        this.show.confirmMessage_1 = true
        setTimeout(function () {
          this.show.answer_2 = true
        }.bind(this), 300)
      }.bind(this), 1000)
    } else {
      setTimeout(function () {
        this.show.writing_1 = false
        this.show.question = true
        this.autoScroll()
        setTimeout(function () {
          this.show.answer_1 = true
          this.autoScroll()
        }.bind(this), 300)
      }.bind(this), 1000)
    }
  },
  watch: {
    pref: function (val) {
      // this.show.next_1 = val !== ''
      // if (this.show.next_1) {
      //   this.autoScroll()
      // }
    },
    workplace: function (val) {
      // this.show.next_2 = val !== ''
      // if (this.show.next_2) {
      //   this.autoScroll()
      // }
    }
  },
  methods: {
    changePrefAction: function () {
      this.isPrefFontBlack = this.pref !== ''
      if (this.pref) {
        this.isDisabled.pref = false
        if (this.isFix.pref) {
          this.btnContent.pref = '更新'
        } else {
          this.btnContent.pref = '次へ'
        }
      } else {
        this.isDisabled.pref = true
      }
    },
    changeWorkplaceAction: function () {
      this.isWorkplaceFontBlack = this.workplace !== ''
      if (this.workplace) {
        this.isDisabled.workplace = false
        if (this.isFix.workplace) {
          this.btnContent.workplace = '更新'
        } else {
          this.btnContent.workplace = '次へ'
        }
      } else {
        this.isDisabled.workplace = true
      }
    },
    clickFixPref: function () {
      this.show.answer_1 = false
      this.isFix.pref = true
      this.isDisabled.pref = true
      this.$emit('form-fix-pref', this.pref)
      this.show.fix_1 = true
      this.autoScroll()
      setTimeout(function () {
        this.show.writing_2 = true
        this.autoScroll()
        setTimeout(function () {
          this.show.writing_2 = false
          this.show.confirmMessage_1 = true
          this.autoScroll()
          setTimeout(function () {
            this.show.answer_2 = true
            this.autoScroll()
          }.bind(this), 300)
        }.bind(this), 1500)
      }.bind(this), 500)
    },
    clickFixWorkplace: function () {
      this.show.answer_2 = false
      this.isFix.workplace = true
      this.isDisabled.workplace = true
      this.$emit('form-fix-workplace', this.workplace)
      this.show.fix_2 = true
      this.autoScroll()
      setTimeout(function () {
        this.show.writing_3 = true
        this.autoScroll()
        setTimeout(function () {
          this.show.writing_3 = false
          this.show.confirmMessage_2 = true
          this.autoScroll()
          this.$emit('form-next')
          // this.nextForm()
        }.bind(this), 1500)
      }.bind(this), 500)
    },
    changePrefData: function () {
      if (this.isFix.pref) {
        this.$emit('form-change-pref', this.pref)
        this.isDisabled.pref = true
      }
    },
    changeWorkplaceData: function () {
      if (this.isFix.workplace) {
        this.$emit('form-change-workplace', this.workplace)
        this.isDisabled.workplace = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .fade {
    &-enter-active, &-leave-active {
      will-change: opacity;
      transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }
    &-enter, &-leave-to {
      opacity: 0;
    }
  }
  .fontBlack {
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/forms/FormPrefAndWorkplace.vue